import { forwardRef } from 'react';
import { Form } from 'rsuite';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Field = forwardRef((props: any, ref: any) => {
  const { name, label, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}-10`} ref={ref} className="mb-4 max-w-[100%]">
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control className="w-[100%] justify-center" name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});
Field.displayName = 'Field';

export default Field;
